import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";

export const crearInversion = async ({usuario, valor, idCampana, conseCapana}) => {

    let conse = await obtenerConsecutivo({col: 'consecutivos', id: 'depositos'})

    let obj = {
        estado: 'Aceptado',
        mensaje: `Inversion para Campaña ${conseCapana}`,
        tipo: 'Inversion',
        valor: valor,
        idUsuario: usuario.id,
        consecutivo: conse.data,
        idCampana: idCampana,
        conseCampana: conseCapana,
    }

    await guardarDoc('depositos', obj)
    await aumentarConsecutivo({col: 'consecutivos', id: 'depositos', actual: conse.data})

}